module.exports = __webpack_public_path__ + "assets/img/6.3a1bc56f.png";